/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react"
import React from "react";
import {dateStringConvert} from "../../Utils/ConvertDate";
import Card from "@material-ui/core/Card";
import {ItemsTable, PrintTemplate} from "../../Utils/Templates/PrintTemplate";
import {detailsTable, smallTable, table} from "../../../styles/tableStyles";


const lastChildPadding = css`
  tr:last-child td{
    padding-bottom: 1rem;
  };
`

export const ReusablePurchaseOrderDetails = ({details, productList, pdfRef, instructions, sub_total,
                                                 arr, prepared_by, approved_by, componentRef}) => {

    const vendor_address = (
        <tbody>
        <tr>
            <td><span>VENDOR ADDRESS</span></td>
        </tr>
        <tr>
            <td><span>{details.supplier_name}</span></td>
        </tr>
        <tr>
            <td><span>{details.supplier_adress}</span></td>
        </tr>
        <tr>
            <td><span>{details.supplier_contact}</span></td>
        </tr>
        </tbody>
    )

    const supplier_address = (
        <tbody>
        <tr>
            <td><span>DELIVER TO</span></td>
        </tr>
        {arr.map((item, index) => (
            <tr key={index}>
                <td><span>{item}</span></td>
            </tr>
        ))}
        </tbody>
    )

    const date = (
        <tbody>
        <tr>
            <td/>
            <td align='right'>
                <span>Date: {details.create_date ? dateStringConvert(details.create_date) : ''}</span>
            </td>
        </tr>
        </tbody>
    )
    const headData = [{key:'item',value:'Item'}, {key:'item_details',value:'Item Details'},
        {key:'quantity',value:'Quantity'}, {key:'rate',value:'Rate'},{key:'total',value:'total'}]

    const itemDetails = (
        <ItemsTable {...{headData}}>
            <tbody>
            {productList.map((product, index) => {
                const count = index += 1;
                return (
                    <tr key={index} className="vendor-row">
                        <td align='center'>{count}</td>
                        <td align='center'>{product.product_name}</td>
                        <td align='center'>{product.quantity}</td>
                        <td align='center'>{product.rate}</td>
                        <td>{product.total}</td>
                    </tr>)
            })}
            <tr>
                <td colSpan={4} align="right">Sub Total</td>
                <td align="center">{sub_total}</td>
            </tr>
            <tr>
                <td colSpan={4} align="right">Tax %</td>
                <td align="center">{details.tax}</td>
            </tr>
            <tr>
                <td colSpan={4} align="right">Total</td>
                <td align="center">{details.grand_total}</td>
            </tr>
            </tbody>
        </ItemsTable>
    )

    const comment_section = (
        <table
            css={[
                detailsTable,
                smallTable,
                lastChildPadding,
            ]}
        >
            <tbody>
            <tr>
                <td><span className="purchase-comment">Comments or Special Instructions</span></td>
            </tr>
            <tr>
                <td><span>{instructions}</span></td>
            </tr>
            </tbody>
        </table>
    )
    const approved_section = (
        <table
            css={[
                detailsTable,
                smallTable,
                lastChildPadding,
            ]}
        >
            <tbody>
            <tr>
                <td><span>Prepared by:</span></td>
                <td align='right'><p>Approved by:</p></td>
            </tr>
            <tr>
                <td><span className="purchase-comment">{prepared_by}</span></td>
                <td align='right'><span className="purchase-comment">{approved_by}</span></td>
            </tr>
            </tbody>
        </table>
    )

    const patientDetails = (
        <>
            {vendor_address}
            {supplier_address}
            {date}
        </>
    )
    const patientNotes = (
        <>
            {comment_section}
            {approved_section}
        </>
    )
    return (
        <Card>
            <div className='p-4' ref={pdfRef}>
                <div ref={componentRef}>
                    <PrintTemplate title='PURCHASE ORDER' {...{
                        patientDetails,
                        itemDetails,
                        patientNotes,
                        patientCellPadding: lastChildPadding
                    }}/>
                </div>
            </div>

        </Card>
    )
}